import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../auth/service';
import { UtilsService } from '../../../../auth/service/utils.service';

@Component({
  selector: 'app-resigned-future-employees',
  templateUrl: './resigned-future-employees.component.html',
  styleUrls: ['./resigned-future-employees.component.scss'],
})
export class ResignedFutureEmployeesComponent implements OnInit {
  public resignedEmployees: any = [];

  constructor(
    private _userService: UserService,
    public _utilsService: UtilsService,
  ) {
  }

  async ngOnInit() {
    this.resignedEmployees = await this._userService.getFutureResignedEmployees();
    this.resignedEmployees = this.resignedEmployees.slice(0, 5);
  }
}
